// extracted by mini-css-extract-plugin
export default {"svg":"ApuJznjygf_q0hMZ67wg"};